module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/ola-najdecka-91f74ae8d2cd59229aaad57818f95901.webp";